import Swiper from 'swiper/bundle'

// Tiles Slides
let tiles = document.getElementsByClassName('slider__tiles')
let tileOptions = {
    speed: 400,
    centeredSlides: true,
    slideToClickedSlide: true,
    centeredSlidesBounds: true,
    watchOverflow: true,
    slidesPerView: 'auto',
    spaceBetween: 0,

    breakpoints: {
        320: {
            slidesPerView: 'auto',
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        },
        // when window width is >= 650px
        650: {
            slidesPerView: 2,
            spaceBetween: 20,
            centeredSlidesBounds: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        },
        // when window width is >= 800px
        800: {
            slidesPerView: 3,
            spaceBetween: 10,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        },
        // when window width is >= 950px
        950: {
            slidesPerView: 4,
            spaceBetween: 20
        }
    },
}

for (var i = 0, len = tiles.length; i < len; i++) {
    new Swiper(tiles[i], tileOptions)
}

// Featured Team Slider
// Tiles Slides
let team = document.getElementsByClassName('slider__team')
let teamOptions = {
    speed: 400,
    centeredSlides: false,
    slideToClickedSlide: true,
    centeredSlidesBounds: false,
    watchOverflow: true,
    slidesPerView: 'auto',
    spaceBetween: 0,

    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 'auto',
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
            },
        },
        // when window width is >= 576px
        576: {
            slidesPerView: 2,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
            },
        },
        // when window width is >= 800px
        800: {
            slidesPerView: 3,
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        }
    },
}

for (var i = 0, len = team.length; i < len; i++) {
    new Swiper(team[i], teamOptions)
}
